// tslint:disable
/**
 * Document number generator API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface NumberSequenceEdit
 */
export interface NumberSequenceEdit {
    /**
     * 
     * @type {string}
     * @memberof NumberSequenceEdit
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof NumberSequenceEdit
     */
    type: NumberSequenceEditTypeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum NumberSequenceEditTypeEnum {
    Unset = 'unset',
    Contract = 'contract',
    Act = 'act',
    Bill = 'bill',
    LearningRequest = 'learning_request',
    FinalDocument = 'final_document',
    EducationProtocol = 'education_protocol',
    EnrollmentOrder = 'enrollment_order',
    ExpulsionOrder = 'expulsion_order'
}



